import { MouseEventHandler, ReactNode } from 'react'
import * as S from './ButtonV2.styles'

interface Props {
  children: ReactNode,
  disabled?: boolean
  className?: string
  onClick?: MouseEventHandler
}

export default ({
  disabled = false, children, className, onClick,
}: Props) => (
  <S.Button
    className={className}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </S.Button>
)
